import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Suspense } from 'react';
import { Placeholder } from 'semantic-ui-react';
import { isServerSideRendering } from '../../utils/gatsby';
var LazyEmbed = /*#__PURE__*/React.lazy(function () {
  return import('semantic-ui-react/dist/commonjs/modules/Embed');
});

var Map = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Map, _React$Component);

  function Map() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Map.prototype;

  _proto.getFormattedAddress = function getFormattedAddress() {
    var _this$createAddressCo = this.createAddressComponents(),
        street = _this$createAddressCo.street,
        locality = _this$createAddressCo.locality;

    return street + ", " + locality;
  };

  _proto.createAddressComponents = function createAddressComponents() {
    var address = this.props.address;
    var street = address.street,
        city = address.city,
        state = address.state,
        zip = address.zip,
        country = address.country;
    var locality = city + ", " + state + " " + zip;
    return {
      street: street,
      locality: locality,
      country: country
    };
  };

  _proto.createMapLink = function createMapLink() {
    var businessName = this.props.businessName;
    var formattedAddress = this.getFormattedAddress(); // Link constants

    var embedBase = "https://www.google.com/maps/embed/v1/place?key=" + process.env.GOOGLE_MAPS_API_KEY + "&q="; // Address query

    var query = encodeURIComponent(businessName ? businessName + " " + formattedAddress : formattedAddress);
    return "" + embedBase + query;
  };

  _proto.render = function render() {
    var isSSR = isServerSideRendering();
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isSSR && /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement(Placeholder, {
        className: "map"
      }, /*#__PURE__*/React.createElement(Placeholder.Image, null))
    }, /*#__PURE__*/React.createElement(LazyEmbed, {
      url: this.createMapLink(),
      active: true,
      className: "map"
    })));
  };

  return Map;
}(React.Component);

export { Map as default };
Map.defaultProps = {
  businessName: ''
};